import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotFound from "../page/NotFound";
import Login from "../page/Login";
import Membership from "../page/Membership";
import BulkPage from "../page/BulkPage";
import { useAuth } from "../context/AuthContext";
import MembershipInfo from "../page/MembershipInfo";
import WeeklyMeets from "../page/WeeklyMeets";
import MeetUps from "../page/MeetUps";
import Referral from "../page/Referral";
import ClosedBusiness from "../page/ClosedBusiness";
import Visitors from "../page/Visitors";
import ActiveMemberRoster from "../page/ActiveMemberRoster";
import MemberActivityReport from "../page/MemberActivityReport";
import ClosedBusinessReport from "../page/ClosedBusinessReport";
import GeneralClosedBusinessReport from "../page/GeneralClosedBusinessReport";
import MemberIndividualReport from "../page/MemberIndividualReport";
import MemberExtendedReport from "../page/MemberExtendedReport";
import AllMemberIndividualReport from "../page/AllMemberIndividualReport";
import OverallActivityReport from "../page/OverallActivityReport";
import ForgotPassword from "../page/ForgotPassword";
import ResetPassword from "../page/ResetPassword";

export const KnownRoutes = () => {
  const { isLoggedIn, user } = useAuth();

  const getHomeRedirect = () => {
    if (!isLoggedIn) return "/login";
    if (user?.role === "ADMIN") return "/membership";
    return "/member/membership";
  };

  const requireAuth = (element, allowedRoles) => {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    if (allowedRoles && !allowedRoles.includes(user?.role || "")) {
      return <Navigate to={getHomeRedirect()} replace />;
    }
    return element;
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to={getHomeRedirect()} replace />} />

      <Route path="404" element={<NotFound />} />

      <Route path="/login" element={<Login />} caseSensitive />
      <Route
        path="/forgot-password"
        element={<ForgotPassword />}
        caseSensitive
      />
      <Route path="/reset-password" element={<ResetPassword />} caseSensitive />

      {/* ADMIN */}
      <Route
        path="/membership"
        element={requireAuth(<Membership />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/membership/:id"
        element={requireAuth(<MembershipInfo />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/weekly-meets"
        element={requireAuth(<WeeklyMeets />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/meetups"
        element={requireAuth(<MeetUps />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/referrals"
        element={requireAuth(<Referral />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/closed-business"
        element={requireAuth(<ClosedBusiness />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/visitors"
        element={requireAuth(<Visitors />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/active-member-roster"
        element={requireAuth(<ActiveMemberRoster />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/member-activity-report"
        element={requireAuth(<MemberActivityReport />, ["ADMIN", "MEMBER"])}
        caseSensitive
      />
      <Route
        path="/closed-business-report"
        element={requireAuth(<ClosedBusinessReport />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/general-closed-business-report"
        element={requireAuth(<GeneralClosedBusinessReport />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/member-individual-report"
        element={requireAuth(<MemberIndividualReport />, ["ADMIN", "MEMBER"])}
        caseSensitive
      />
      <Route
        path="/member-extended-report"
        element={requireAuth(<MemberExtendedReport />, ["ADMIN", "MEMBER"])}
        caseSensitive
      />
      <Route
        path="/all-active-member-report"
        element={requireAuth(<AllMemberIndividualReport />, ["ADMIN"])}
        caseSensitive
      />
      <Route
        path="/overall-activity-report"
        element={requireAuth(<OverallActivityReport />, ["ADMIN", "MEMBER"])}
        caseSensitive
      />

      {/* MEMBER */}
      <Route
        path="/member/membership"
        element={requireAuth(<Membership />, ["MEMBER"])}
        caseSensitive
      />
      <Route
        path="/member/bulk"
        element={requireAuth(<BulkPage />, ["MEMBER"])}
        caseSensitive
      />
    </Routes>
  );
};
